var map = {
	"./defaultLogo.png": 1226,
	"./resources/logos/header/headerLogo.png": 1220,
	"./resources/main": 464,
	"./resources/main.json": 464,
	"./resources/robots/Flexa/Flexa.png": 1221,
	"./resources/robots/L50/L50.png": 1222,
	"./resources/robots/Leovac/leovac.png": 1223,
	"./resources/robots/S75/S75.png": 1224,
	"./resources/robots/V40/V40.png": 1225
};
var fakeMap = {
	"464": 3,
	"1220": 9,
	"1221": 9,
	"1222": 9,
	"1223": 9,
	"1224": 9,
	"1225": 9,
	"1226": 9
};

function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, fakeMap[id])
	});
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 1931;
module.exports = webpackAsyncContext;